import { useSelector } from 'react-redux';
import { MenuState } from '@/reducers/menu';

export default function useMenuList() {
  const menuList = useSelector((state: { menu: MenuState }) => state.menu.menuList);

  return menuList;
}
